import { memo } from 'react';

import { useJWT } from '@doger/core/modules/auth';

import { LogAmplitudeEventOnMount } from '@doger/chat/shared/analytics';

import { NewChat } from '../../modules/chat';

export const HomePage = memo(() => {
  const jwt = useJWT();

  return (
    <>
      {!!jwt ? (
        <LogAmplitudeEventOnMount event='New Chat Page Viewed' />
      ) : (
        <LogAmplitudeEventOnMount event='Home Page Viewed' />
      )}

      <NewChat />
    </>
  );
});
